import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "display", "text"]

  generate() {
    const secret = Array.from(crypto.getRandomValues(new Uint8Array(32)))
      .map(b => b.toString(16).padStart(2, "0"))
      .join("")

    this.inputTarget.value = secret

    this.displayTarget.innerHTML = `
      <div class="flex items-center gap-2 mt-1">
        <input type="text" readonly value="${secret}"
               data-fragment-secret-target="text"
               class="text-xs font-mono bg-white dark:bg-gray-900 border border-gray-300 dark:border-gray-600 rounded px-2 py-1 flex-1 text-gray-700 dark:text-gray-300" />
        <button type="button" data-action="fragment-secret#copy"
                class="text-xs text-primary-600 hover:underline whitespace-nowrap">Copy</button>
        <button type="button" data-action="fragment-secret#generate"
                class="text-xs text-amber-600 hover:underline whitespace-nowrap">Regenerate</button>
      </div>
      <p class="text-xs text-gray-400 mt-1">Set as <code class="text-xs">X-Fragment-Secret</code> header in your CF Worker. Regenerating will invalidate the current secret.</p>
    `
  }

  copy() {
    const text = this.hasTextTarget ? this.textTarget.value : this.inputTarget.value
    navigator.clipboard.writeText(text)
    const btn = event.currentTarget
    btn.textContent = "Copied!"
    setTimeout(() => btn.textContent = "Copy", 2000)
  }
}
